import request from './request'

export const managementApi = {
  overview: () => request.get('/management/overview/'),
  projects: () => request.get('/management/projects/'),
  createProject: payload => request.post('/management/projects/', payload),
  project: id => request.get(`/management/projects/${id}/`),
  updateProject: (id, payload) => request.patch(`/management/projects/${id}/`, payload),
  serverCapacity: () => request.get('/management/server-capacity/'),
  updateServerCapacity: payload => request.patch('/management/server-capacity/', payload),
  deleteProject: (id, payload) =>
    request.delete(`/management/projects/${id}/`, { data: payload }),
  devices: params => request.get('/management/devices/', { params }),
  device: sid => request.get(`/management/devices/${encodeURIComponent(sid)}/`),
  updateDevice: (sid, payload) =>
    request.patch(`/management/devices/${encodeURIComponent(sid)}/`, payload),
  archiveDevice: (sid, archived) =>
    request.post(`/management/devices/${encodeURIComponent(sid)}/archive/`, { archived }),
  assistants: () => request.get('/management/assistants/'),
  refreshAssistantAccountStatus: () => request.post('/management/assistants/refresh-account-status/'),
  assistantMonitor: params => request.get('/management/assistant-monitor/', { params }),
  batches: params => request.get('/management/batches/', { params }),
  invitations: () => request.get('/management/invitations/'),
  createInvitation: payload => request.post('/management/invitations/', payload),
  respondInvitation: (id, action) =>
    request.post(`/management/invitations/${id}/respond/`, { action }),
  notifications: () => request.get('/management/notifications/'),
  readNotification: id => request.post(`/management/notifications/${id}/read/`)
}
